<template lang="pug">
header
  swiper.swiper-container(:options="swiperOption", ref="mySwiper")
    swiper-slide.swiper-slide(
      v-for="sliderImage in sliderImageList",
      :key="sliderImage.id",
      @click.native="slideClick(sliderImage)"
    )
      a
        img.photo(v-if="sliderImage.photo", :src="sliderImage.photo.image")
    .swiper-pagination.swiper-pagination-white(slot="pagination")
  img.swiper-prev(
    src="@/assets/img/icons/angle-left-solid.svg",
    @click="prevClick"
  )
  img.swiper-next(
    src="@/assets/img/icons/angle-right-solid.svg",
    @click="nextClick"
  )
</template>

<script>
import { getCarouselList } from "@/api/web_content";

export default {
  name: "CustomHeader",
  data() {
    return {
      swiperOption: {
        notNextTick: true,
        initialSlide: 1,
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
          stopOnLastSlide: false,
        },
        direction: "horizontal",
        grabCursor: true,
        setWrapperSize: true,
        autoHeight: false,
        mousewheelControl: true,
        observeParents: true,
        debugger: true,
        paginationClickable: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      sliderImageList: [],
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  created() {
    this.getSliderImages();
  },
  methods: {
    prevClick() {
      this.swiper.slidePrev();
    },
    nextClick() {
      this.swiper.slideNext();
    },
    getSliderImages() {
      getCarouselList().then((response) => {
        this.sliderImageList = response.data;
      });
    },
    slideClick(item) {
      if (item.is_external_link) {
        window.open(item.link);
      } else {
        this.$router.push({ name: "Enroll" });
      }
    },
  },
};
</script>

<style scoped lang="scss">
header {
  position: relative;
}

.swiper-container {
  width: 100%;
  height: auto;
  z-index: 0;

  .swiper-wrapper {
    z-index: 0;
  }

  .number_bg {
    height: 185px;
    width: auto;
    position: absolute;
    top: 0;
    left: 15px;
    top: 45px;
  }
}

img.photo {
  width: 100%;
  height: auto;
}
</style>
